module.exports = __webpack_public_path__ + "static/media/tutors-3.4de860d1.png";